var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLocationBlue = function SvgLocationBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.093,
    height: 19.71,
    viewBox: "0 0 16.093 19.71"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.508 -194.206)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57",
    transform: "translate(76.758 193.961)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 107",
    d: "M84.4,193.964a7.6,7.6,0,0,0-7.639,7.2v.038c.125,4.366,3.95,8.393,7.335,11.755a.754.754,0,0,0,1.062-.019c3.132-3.372,7.275-7.026,7.195-11.943v0a7.555,7.555,0,0,0-7.954-7.033Zm.026,1.3a6.155,6.155,0,0,1,6.509,5.763C91,205,87.67,208.253,84.617,211.492c-3.168-3.2-6.32-6.842-6.43-10.3a6.178,6.178,0,0,1,6.236-5.93Z",
    transform: "translate(-76.758 -193.466)",
    fill: "#0067b9",
    stroke: "#0067b9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 78",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(6 6)",
    fill: "#0067b9"
  })))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4wOTMiIGhlaWdodD0iMTkuNzEiIHZpZXdCb3g9IjAgMCAxNi4wOTMgMTkuNzEiPg0KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzYuNTA4IC0xOTQuMjA2KSI+DQogICAgPGcgZGF0YS1uYW1lPSJHcm91cCA1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzYuNzU4IDE5My45NjEpIj4NCiAgICAgIDxwYXRoIGRhdGEtbmFtZT0iUGF0aCAxMDciIGQ9Ik04NC40LDE5My45NjRhNy42LDcuNiwwLDAsMC03LjYzOSw3LjJ2LjAzOGMuMTI1LDQuMzY2LDMuOTUsOC4zOTMsNy4zMzUsMTEuNzU1YS43NTQuNzU0LDAsMCwwLDEuMDYyLS4wMTljMy4xMzItMy4zNzIsNy4yNzUtNy4wMjYsNy4xOTUtMTEuOTQzdjBhNy41NTUsNy41NTUsMCwwLDAtNy45NTQtNy4wMzNabS4wMjYsMS4zYTYuMTU1LDYuMTU1LDAsMCwxLDYuNTA5LDUuNzYzQzkxLDIwNSw4Ny42NywyMDguMjUzLDg0LjYxNywyMTEuNDkyYy0zLjE2OC0zLjItNi4zMi02Ljg0Mi02LjQzLTEwLjNhNi4xNzgsNi4xNzgsMCwwLDEsNi4yMzYtNS45M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03Ni43NTggLTE5My40NjYpIiBmaWxsPSIjMDA2N2I5IiBzdHJva2U9IiMwMDY3YjkiIHN0cm9rZS13aWR0aD0iMC41Ii8+DQogICAgICA8Y2lyY2xlIGRhdGEtbmFtZT0iRWxsaXBzZSA3OCIgY3g9IjIiIGN5PSIyIiByPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2IDYpIiBmaWxsPSIjMDA2N2I5Ii8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgLocationBlue as ReactComponent };